<template>
<div class="sa-presc-det">
  <template v-if="!loader">
      <general-info ref="GenericDetails" :generic="generic" v-if="saveDrugViewFlag" />
      <div v-if="!saveDrugViewFlag" class="sa-mob-header">
      <h5 class="sa-card-tit">Prescription</h5>
      <button class="sa-btn-back" @click="backAction('end')">
          <i class="icon-arrow-left"></i>
        </button>
      </div>
      <!-- <h6 class="sa-card-tit" v-if="saveDrugViewFlag" :class="saveDrugViewFlag ? 'sa-mob-mt20':''">Medicines Details</h6> -->
    <div class="sa-med-accord sa-mob-cont-padbt" :class="saveDrugViewFlag ? '':'sa-mob-cont'">
      <h6 v-if="drugList?.length" class="sa-card-tit" >Medicines Details</h6>
      <div v-for="(drug, index) in drugList" :key="index">  
        <div v-if=" generic.sales_channel == 'bupa_refill' && removedFlag" ref="details" @click="drugDetailsAPI(drug.drgid, $event)" class="sa-med-accord-tit">{{drug.drug_nm}} <span v-if="drug.ACTION == 'Removed'" class="sa-red-text">Removed</span>
            </div>
            <div v-else ref="details" @click="drugDetailsAPI(drug.drgid, $event)" class="sa-med-accord-tit">{{drug.drug_nm}}
            </div>
        <div class=" sa-med-accord-cont" >
          <template  v-if="drugDetails">
              <div class="sa-mb30 sa-h-xs">
                <strong class="sa-d-block">{{drugDetails.drug_nm}} </strong>
                <small class="sa-dark-gray-text"> {{drugDetails.dose}}</small>
              </div>
              <div class="sa-row ">
                <div class="sa-col-xs6 sa-col-sm6 sa-col-md5 sa-col-lg3">
                  <label>Dose</label>
                  <span>{{drugDetails.dose}}</span>
                </div>
                <div class="sa-col-xs6 sa-col-sm6 sa-col-md5 sa-col-lg3">
                  <label>Dose Unit</label>
                  <span>{{drugDetails.dose_unit}}</span>
                </div>
                <div class="sa-col-xs6 sa-col-sm6 sa-col-md5 sa-col-lg3">
                  <label>Route</label>
                  <span>{{drugDetails.route}}</span>
                </div>
                <div class="sa-col-xs6 sa-col-sm6 sa-col-md5 sa-col-lg3">
                  <label>Frequency</label>
                  <span>{{drugDetails.freq_nm}}</span>
                </div>
                <div class="sa-col-xs6 sa-col-sm6 sa-col-md5 sa-col-lg3">
                  <label>Duration</label>
                  <span>{{drugDetails.dur}}</span>
                </div>
                <div class="sa-col-xs6 sa-col-sm6 sa-col-md5 sa-col-lg3">
                  <label>Duration Unit</label>
                  <span>{{drugDetails.dur_unit}}</span>
                </div>
                <div class="sa-col-xs6 sa-col-sm6 sa-col-md5 sa-col-lg3">
                  <label>PRN</label>
                  <span>{{drugDetails.prn}}</span>
                </div>
                <div class="sa-col-xs6 sa-col-sm6 sa-col-md5 sa-col-lg3">
                  <label>Indications</label>
                  <span>{{drugDetails.indications}}</span>
                </div>
                <div class="sa-col-xs6 sa-col-sm6 sa-col-md5 sa-col-lg3">
                  <label>Instructions</label>
                  <span>{{drugDetails.inst}}</span>
                </div>
                <div class="sa-col-xs6 sa-col-sm6 sa-col-md5 sa-col-lg3">
                  <label>Scientific Name</label>
                  <span>{{drugDetails.scientific_name}}</span>
                </div>
                 <div v-if="removedFlag" class="sa-col-xs6 sa-col-sm6 sa-col-md5 sa-col-lg3">
                  <label>Reason</label>
                  <span>{{drugDetails.reason}}</span>
                </div>
            </div>
          </template>
          <div v-else class="sa-text-center">
            <img src="../../../../assets/img/loader.svg" alt="loader" />
          </div>
          <div class="sa-d-flex" v-if="!saveDrugViewFlag && !removedFlag">
            <a v-if="!bupaRemove && generic.sales_channel == 'bupa_refill'" class="sa-red-text">
              <i class="icon-trash sa-mr10 h5"></i>
              <span v-if="!bupaRemove"  @click="bupacheck" class="sa-text-underline">Remove</span>
            </a>
            <a v-else-if="!bupaRemove" class="sa-red-text">
              <i class="icon-trash sa-mr10 h5"></i>
              <span   @click="removeDrug(drugDetails.drgid)" class="sa-text-underline">Remove</span>
            </a>
            <a v-if="!bupaRemove" class="sa-blue-text sa-ml30"> 
              <i class="icon-edit2 sa-mr10 h5"></i>
              <span  @click="editDrug(drugDetails.drgid)" class="sa-text-underline">Edit Details</span>
            </a>
             
          </div>
          <div  v-if="bupaRemove">
            <label>Reason<span class="sa-red-text">*</span></label>
          <input type="text"
                id="fname"
                v-model="reason"
                class="sa-form-control sa-form-control-lg" 
              />
          </div>
          
          <button v-if="bupaRemove" class="sa-btn sa-btn-large sa-btn-default" @click="removeBupaDrug(drugDetails.drgid)">Remove Medicine</button>
        </div>
      </div>
      <!-- // new ...........Milk  changes -->
      <h6 v-if="listData?.milk?.length" class="sa-card-tit" >Milk Details</h6>
      <div v-if="listData?.milk?.length" v-for="(drug, index) in listData.milk" :key="index">
        <div ref="details" @click="prescribedDet(drug.mlk_id,1, $event)" class="sa-med-accord-tit">{{drug.mlk_nme}}
        </div>
        <div class=" sa-med-accord-cont" >
          <template  v-if="prescribedItem">
            <div class="sa-mb30 sa-h-xs">
                <strong class="sa-d-block">{{prescribedItem.srv_nme}} </strong>
            </div>
            <div class="sa-row ">
                <div class="sa-col-xs6 sa-col-sm6 sa-col-md5 sa-col-lg3">
                  <label>Instructions</label>
                  <span>{{prescribedItem.inst}}</span>
                </div>
                <div class="sa-col-xs6 sa-col-sm6 sa-col-md5 sa-col-lg3">
                  <label>Quantity</label>
                  <span>{{prescribedItem.quantity}}</span>
                </div>
                <div class="sa-col-xs6 sa-col-sm6 sa-col-md5 sa-col-lg3">
                  <label>Indications</label>
                  <span>{{prescribedItem.indications}}</span>
                </div>
            </div>
          </template>
          <div class="sa-d-flex" v-if="!saveDrugViewFlag && !removedFlag">
            <a class="sa-red-text">
              <i class="icon-trash sa-mr10 h5"></i>
              <span   @click="removePrescribedItem(prescribedItem.item_id,1)" class="sa-text-underline">Remove</span>
            </a>
            <a v-if="!bupaRemove" class="sa-blue-text sa-ml30"> 
              <i class="icon-edit2 sa-mr10 h5"></i>
              <span  @click="editPrescribedItem(prescribedItem,1)" class="sa-text-underline">Edit Details</span>
            </a>
             
          </div>
        </div>
      </div>

      <!-- // new ...........Medical Supplies  changes -->
      <h6 v-if="listData?.supplies?.length" class="sa-card-tit" >Medical Supplies</h6>
      <div v-if="listData?.supplies?.length" v-for="(drug, index) in listData.supplies" :key="index">
        <div ref="details" @click="prescribedDet(drug.sup_id,2, $event)" class="sa-med-accord-tit">{{drug.sup_nme}}
        </div>
        <div class=" sa-med-accord-cont" >
          <template  v-if="prescribedItem">
            <div class="sa-mb30 sa-h-xs">
                <strong class="sa-d-block">{{prescribedItem.srv_nme}} </strong>
            </div>
            <div class="sa-row ">
                <div class="sa-col-xs6 sa-col-sm6 sa-col-md5 sa-col-lg3">
                  <label>Instructions</label>
                  <span>{{prescribedItem.inst}}</span>
                </div>
                <div class="sa-col-xs6 sa-col-sm6 sa-col-md5 sa-col-lg3">
                  <label>Quantity</label>
                  <span>{{prescribedItem.quantity}}</span>
                </div>
                <div class="sa-col-xs6 sa-col-sm6 sa-col-md5 sa-col-lg3">
                  <label>Indications</label>
                  <span>{{prescribedItem.indications}}</span>
                </div>
            </div>
          </template>
          <div class="sa-d-flex" v-if="!saveDrugViewFlag && !removedFlag">
            <a class="sa-red-text">
              <i class="icon-trash sa-mr10 h5"></i>
              <span   @click="removePrescribedItem(prescribedItem.item_id,2)" class="sa-text-underline">Remove</span>
            </a>
            <a v-if="!bupaRemove" class="sa-blue-text sa-ml30"> 
              <i class="icon-edit2 sa-mr10 h5"></i>
              <span  @click="editPrescribedItem(prescribedItem,2)" class="sa-text-underline">Edit Details</span>
            </a>
             
          </div>
        </div>
      </div>

        <!-- // new ...........Medical Deviece  changes -->
        <h6 v-if="listData?.devices?.length" class="sa-card-tit" >Medical Devices</h6>
      <div v-if="listData?.devices?.length" v-for="(drug, index) in listData.devices" :key="index">
        <div ref="details" @click="prescribedDet(drug.dev_id,3, $event)" class="sa-med-accord-tit">{{drug.dev_nme}}
        </div>
        <div class=" sa-med-accord-cont" >
          <template  v-if="prescribedItem">
            <div class="sa-mb30 sa-h-xs">{{prescribedItem}}
                <strong class="sa-d-block">{{prescribedItem.srv_nme}} </strong>
            </div>
            <div class="sa-row ">
                <div class="sa-col-xs6 sa-col-sm6 sa-col-md5 sa-col-lg3">
                  <label>Instructions</label>
                  <span>{{prescribedItem.inst}}</span>
                </div>
                <div class="sa-col-xs6 sa-col-sm6 sa-col-md5 sa-col-lg3">
                  <label>Quantity</label>
                  <span>{{prescribedItem.quantity}}</span>
                </div>
                <div class="sa-col-xs6 sa-col-sm6 sa-col-md5 sa-col-lg3">
                  <label>Indications</label>
                  <span>{{prescribedItem.indications}}</span>
                </div>
            </div>
          </template>
          <div class="sa-d-flex" v-if="!saveDrugViewFlag && !removedFlag">
            <a class="sa-red-text">
              <i class="icon-trash sa-mr10 h5"></i>
              <span   @click="removePrescribedItem(prescribedItem.item_id,3)" class="sa-text-underline">Remove</span>
            </a>
            <a v-if="!bupaRemove" class="sa-blue-text sa-ml30"> 
              <i class="icon-edit2 sa-mr10 h5"></i>
              <span  @click="editPrescribedItem(prescribedItem,3)" class="sa-text-underline">Edit Details</span>
            </a>
             
          </div>
        </div>
      </div>
      
    </div>
    
    <div class="sa-ftr-btn"> 
      <template :disabled="load"   v-if="!saveDrugViewFlag">
      <button :disabled="load"  v-if="listData.prescflags && listData.prescflags.new_presc_flow" class="sa-btn sa-btn-large sa-btn-default" @click="onAddItems()">Add item</button>
      <button :disabled="load"   v-else class="sa-btn sa-btn-large sa-btn-default" @click="addMedicine">Add Medicine</button>
      <button :disabled="load" class="sa-btn sa-btn-large sa-btn-primary sa-ml20" @click="saveDrug">Continue</button>
      </template>
      <button :disabled="load" class="sa-btn sa-btn-large sa-btn-primary sa-btn-block-xs" @click="issuePrescription" v-if="saveDrugViewFlag">Issue Prescription</button>
    </div>
    <div class="sa-dialog" v-show="fullImageModal " @click="fullImageModal = false" >
      <div class="sa-dialog-body sa-extra-small sa-text-center">
        <span class="sa-sprite sa-drug-save"></span>
        <h6 class="sa-font-normal">Prescription has been saved successfully</h6>
        <h6>Reference ID: PR-{{$route.params.appid}}</h6> 
        <button class="sa-btn sa-btn-large sa-btn-primary sa-mt30 a-btn-w100 " @click="backAction('complete')">Continue</button>
      </div>
    </div>
  </template>
  <img v-if="loader" src="../../../../assets/img/loader.svg" alt="loader" class="sa-loader" />
  <MedicalItemsListPopup :listData="listData" :prescribedItem="prescribedItem" :Items="Items" :editItemFlag="editItemFlag" :drugList="drugList" :medicalItems="listData.prescitems" v-if="isMedicalItemList" @close-pop="closePopup()"/>
</div>
</template>
<script>
import { pro_url, oh_url } from '../../../../../config/endpoints';
import GeneralInfoVue from './GeneralInfo.vue';
import MedicalItemsListPopup from './MedicalItemsListPopup.vue';
import AddProductMedicine from './AddProductMedicine.vue';
export default {
  props: ['drugList', 'generic','listData','load' ],
  components: {
    'general-info': GeneralInfoVue,
    MedicalItemsListPopup,
    AddProductMedicine
  },
  data() {
    return {
      Items:null,
      editItemFlag:false,
      isMedicalItemList:false,
      reason:null,
      bupaRemove:false,
      tabSelection: 'diagTab2',
      open2:true,
      fullImageModal:false,
      saveDrugFlag: false,
      saveDrugViewFlag: false,
      drugDetails: null,
      loading: false,
      loader: false,
      removedFlag:false,
      prescribedItem:null
    };
  },
  methods: {
    onAddItems(){
      this.isMedicalItemList = false
      this.editItemFlag = false
      this.isMedicalItemList = !this.isMedicalItemList
    },
    bupacheck(){
      this.bupaRemove = true
    },
    backAction: function(event) {
      // webview back button
      if (typeof window!=undefined && window.ReactNativeWebView) {
        let data = {
          action: event            
        }
        window.ReactNativeWebView.postMessage(JSON.stringify(data));
      }
      this.$router.push('/appointments/doctor-details/add-diagnosis/'+this.$route.params.appid)
      // window.location = '/appointments/doctor-details/add-diagnosis/'+this.$route.params.appid
    },
    issuePrescription: function () {
      let _self = this      
    
        _self.loader = true
        _self.$store.dispatch('httpPost', {
          uri: `${pro_url}/prescription/issue`,
          body: {
            apnt_id: _self.$route.params.appid
            // presc_desc: _self.$refs['GenericDetails'].presc_desc
          }
        }).then(response => {
            _self.loader = false
            if (response && response.status == '1000') {
              // webview back button
              if (typeof window!=undefined && window.ReactNativeWebView) {
                let data = {
                  action: 'back',
                  page: 'complete'
                }
                window.ReactNativeWebView.postMessage(JSON.stringify(data));
              }
              _self.fullImageModal = true
            } else {
              _self.$store.dispatch("SET_ALERTMESSAGE", {
                msg: "Something went wrong. Please try again or contact operations team",
                class: "sa-a-danger"
              });
            }
          })
        
    },
    removeBupaDrug (drgid) {
      this.$parent.reason = this.reason
      this.$emit('removeBupaDrug', drgid)
      this.reason = null
    },
    removeDrug (drgid) {
      this.$emit('removeDrug', drgid)
    },
    removePrescribedItem(drgid,type) {
      this.viewMedFlag = false;
      this.loading = true;
      let _self = this;
     let name = "Milk"
      if(type == 2){
        name = "Medical Devices"
      }else if(type == 3){
        name = "Medical Supplies"
      }
      _self.$store
        .dispatch("httpPost", {
          uri: `${oh_url}/pro/deletePrescribedItems`,
          body: {
            item_id: drgid,
            type: type
          },
        })
        .then((response) => {
          _self.loading = false;
          if (response && response.status === 1000) {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Deleted " + name + " successfully",
              class: "sa-a-success",
            });
            _self.$parent.fetchList(function () {});
          } else {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Something went wrong. Please try again or contact operations team",
              class: "sa-a-danger",
            });
          }
        });
    },
    editDrug (drgid) {
      this.$emit('editDrug', drgid)
    },
    editPrescribedItem (item,type) {
      for(let e of this.listData.prescitems.prescr_items){
          if(type == 1){
             if(e.name == "Add Milk"){
                this.Items = e
             }
          }else if(type == 2){
             if(e.name == "Add Medical Device"){
                this.Items = e
             }
          }else if(type == 3){
             if(e.name == "Add Medical Supplies"){
                this.Items = e
             }
          }
      }
      this.editItemFlag = true
      this.isMedicalItemList = true
      
    },
    
    drugDetailsAPI(drgid, e) {
      if (this.$refs.details && this.$refs.details.length) {
        this.$refs.details.forEach((el)=>{el.className = "sa-med-accord-tit";})
      }
      if (e) {
        e.target.className = 'sa-med-accord-tit active'
      } else {
        this.$refs.details[0].className = "sa-med-accord-tit active"
      }
      let _self = this
      this.loading = true
      _self.$store.dispatch('httpGet', {
        uri: `${pro_url}/prescription/Details/${drgid}`
      }).then(response => {
        if (response && response.status === 1000) {
          _self.drugDetails = response.data
          if(response.data && response.data.ACTION && response.data.ACTION == 'Removed'){

          _self.removedFlag = true
          }else{
            _self.removedFlag = false
          }
          this.loading = false
        }
      })

    },
    addMedicine () {
      // webview back button
      if (typeof window!=undefined && window.ReactNativeWebView) {
        let data = {
          action: 'back',
          page: 'add medicine'
        }
        window.ReactNativeWebView.postMessage(JSON.stringify(data));
      }
      this.$parent.editflag = false
      this.$parent.viewMedFlag = false
      this.$parent.drgid = null
      this.$parent.checkbox = false
      this.$parent.drugObj ={
                  apnt_id: null,
                  scientific_name: null,
                  pid: null,
                  drug_nm: null,
                  dose: null,
                  route: null,
                  dose_unit: null,
                  freq_nm: null,
                  dur: null,
                  dur_unit: null,
                  prn: "NO",
                  pharm:null,
                  indications: null,
                  icd10_code: {
                    en: null,
                    icd10_code: null
                  },
                  inst: null,
                }
    },
    saveDrug(){
      // webview back button
      if (typeof window!=undefined && window.ReactNativeWebView) {
        let data = {
          action: 'back',
          page: 'issue prescription'
        }
        window.ReactNativeWebView.postMessage(JSON.stringify(data));
      }
      let _self = this;
      if(!_self.saveDrugFlag){
        _self.saveDrugFlag = true
        _self.saveDrugViewFlag = true
      }else {
        _self.saveDrugFlag = false
        _self.saveDrugViewFlag = false
      }
    },
    closePopup(){
      this.isMedicalItemList = false
      this.editItemFlag = false
      this.$parent.fetchList()
    },
    prescribedDet(pid,type, e) {
      if (this.$refs.details && this.$refs.details.length) {
        this.$refs.details.forEach((el)=>{el.className = "sa-med-accord-tit";})
      }
      if (e) {
        e.target.className = 'sa-med-accord-tit active'
      } else {
        this.$refs.details[0].className = "sa-med-accord-tit active"
      }
      let _self = this
      this.loading = true
      _self.$store.dispatch('httpPost', {
        uri: `${oh_url}/pro/prescribedItems/details`,
        body: {
          type:type,
          item_id: pid
        }
      }).then(response => {
        if (response && response.status === 1000) {
          _self.prescribedItem = response.data
          if(response.data && response.data.ACTION && response.data.ACTION == 'Removed'){

          _self.removedFlag = true
          }else{
            _self.removedFlag = false
          }
          this.loading = false
        }
      })

    },
  },

  mounted() {
    this.isMedicalItemList = false
      this.editItemFlag = false
    this.$parent.day_cnt = null
    if(this?.drugList?.length){
      this.drugDetailsAPI(this?.drugList[0]?.drgid)
    }
      
  },
};
</script>
